import '../components/axios.js';
import { Collapse, Alert } from 'bootstrap';
import { getPublicUrl } from '../components/utils.js';
import Cookie from '../../../../dev/js/components/cookie.js';
import AuthService from '../services/auth-service.js';
import ReCaptchaService from '../services/recaptcha-service.js';
import initPrototypes from '../components/prototypes.js';

window.dataLayer = window.dataLayer || [];
window.Cookie = Cookie;
initPrototypes();

class Categories {
	constructor() {
		window.authService = this.authService = new AuthService();
		this.authService.init();
		window.reCaptchaService = this.reCaptchaService = new ReCaptchaService();
		this.reCaptchaService.init(); // TODO: it can be deleted after public.js isn't used anymore

		this.input = document.getElementById('search');
		this.switchElement = document.getElementById('switch');
		this.tagCloud = document.getElementById('tag-cloud');
		this.sections = {};

		this.initSectionCollapses();
		this.initSearch();
		this.initFilter();
	}

	initSectionCollapses() {
		let lists = document.querySelectorAll('section.category-list');
        lists.forEach((section) => {
            this.sections[section.getAttribute('id')] = new Collapse(section, {
                toggle: false,
            });
        });
	}

	initFilter() {
		this.switchElement.addEventListener('change', (e) => {
			window.Cookie.set('ti-categories-switch', e.target.checked, 24);
		});
		const switched = window.Cookie.get('ti-categories-switch');
        if (switched) {
            this.switchElement.checked = switched === 'true';
            (new Collapse(document.getElementById('tag-cloud'), {
                toggle: switched === 'false',
            }));
        }

		let tags = document.querySelectorAll('input[type="checkbox"][name="tags"]')
		tags.forEach((element) => element.addEventListener('change', (e) => {
			let checkedValues = this.getCheckedValues();
			this.manageSections(checkedValues);
			window.Cookie.set('ti-categories-tags', JSON.stringify(checkedValues), 24);
		}));

		let stored = window.Cookie.get('ti-categories-tags');
		if (stored) {
			let slugs = JSON.parse(stored) || [];
			this.manageSections(slugs);
		}
	}

	initSearch() {
		this.input.addEventListener('change', (e) => {
			if (e.target.value.length > 2) {
				this.getCompanies(function () {
					e.target.focus();
				});
			}
		});
	}

	getCompanies(callback) {
		let url = `${getPublicUrl()}/api/categories`;
		let keyword = this.input.value;

		reCaptchaService.runWithCaptcha(
			"category_companies_search",
			function (token, withCheckbox = false) {
				return axios
					.post(url, {
						keyword,
						recaptcha_token: token,
						recaptcha_checkbox: withCheckbox,
					})
					.then((response) => {
						console.log("category_companies_search", response);

						let loadedCompanies = response.data;

						document.querySelector('.search-container ul.search-results').innerHTML = loadedCompanies;

						if (callback) {
							callback();
						}
					})
					.catch((error) => {
						console.error("category_companies_search", error);
					});
			});
	}

	getCheckedValues() {
		const checkboxes = document.querySelectorAll('input[type="checkbox"][name="tags"]');
		const checkedValues = [];

		checkboxes.forEach(checkbox => {
			if (checkbox.checked) {
				checkedValues.push(checkbox.value);
			}
		});

		return checkedValues;
	}

	manageSections(slugs) {
		if (slugs.length > 0) {
			slugs.forEach((element) => {
				document.getElementById(`toggle-${element}`).checked = true;
            });
			document.querySelectorAll('section.category-list').forEach(section => {
				let elementId = section.getAttribute('id');
				if (slugs.indexOf(elementId) > -1) {
					document.getElementById(`toggle-${elementId}`).checked = true;
					this.sections[elementId].show();
				} else {
					document.getElementById(`toggle-${elementId}`).checked = false;
					this.sections[elementId].hide();
				}
			});
		} else {
			Object.values(this.sections).map((element) => element.show());
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new Categories();
});